import gql from 'graphql-tag';

export default gql`
mutation insertProjectTag($projectId: Int!, $tagId: Int!) {
  insert_projects_tags(objects: {tag_id: $tagId, project_id: $projectId}) {
    affected_rows
  }
}
`;
